import React, { useEffect, useState, useRef } from 'react'
import { FormattedMessage } from 'react-intl';
import commonFunctions from '../../utils/commonFunctions';
import './HardwareWarranty.css'
import Table from '../../components/Table/Table'
import CompanySelectTable from './CompanySelect'
import ImportModal from './ImportModal'
import HwModal from './HwModal'
import API from '../../utils/API'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import constants from '../../utils/constants'
import tableCheckbox from '../../components/Inputs/tableCheckbox'
import InputValidation from '../../utils/InputValidation'
import useInfiniteScroll from '../../components/common/useInfiniteScroll';

function HardwareWarranty(props) {
  const navigate = useNavigate();
  const { closeModal } = commonFunctions;
  const { user } = props;
  const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const permissionIds = user.permissions.map((permission)=>{
    return permission.id
  })
  
  useEffect(() => {
    if(!permissionIds.includes(constants.permissionIds.hwWarrantyEdit) && !permissionIds.includes(constants.permissionIds.hwWarrantyRead)){
      navigate('/forbidden');
    }
  }, [navigate, permissionIds]);

  const [checkedRxExpiration, setCheckedRxExpiration] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [hasBeenFiltered, setHasBeenFiltered] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  // Give state to all components of the dataMap(explained later) you want to render
  const [data, setData] = React.useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [selectedIds, setSelectedIds] = useState({});
  const [sortByCol, setSortByCol] = useState('mac');
  const [sortByAsc, setSortByAsc] = useState(true);
  const [startIndexForTable, setStartIndexForTable] = useState(0);
  const [searchValue, setSearchValue] = useState('');

  // Company Select states
  const [companies, setCompanies] = useState([]);

  const [selectedCompanyImport, setSelectedCompanyImport] = useState("");
  const [importFile, setImportFile] = useState(null);
  const [checkedRxExpirationValid, setcheckedRxExpirationValid] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const isSupportUser = user.permissions.some(permission=>permission.id === constants.permissionIds.support);
  const modalId = isSupportUser ? 'hwModal' : null;

  const tableRef = useRef();
  const tableWrapperRef = useRef();

  const hwDataMap = React.useMemo(() => {
    const map = { data: {}, ids: [], selectedIds: {}, filteredIds: [] };
    loadTable(map);
    return map;
  }, []);

  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap: hwDataMap,
    setData,
    startIndexForTable,
    setStartIndexForTable,
    pageSize: 100, 
    sortByCol,
    setSortByCol,
    sortByAsc, 
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
  });

  /**
   * Display receivers for a selected company
   * @param {*} accountId - The account ID of the selected company
   */
  function displayReceivers(accountId) {
    console.log('Displaying receivers for company:', accountId);
    loadTable(hwDataMap, true, accountId);
  }

  function loadTable(map, resetSelection = true, selectedCompany=null) {
    // Reset map
    map.data = {};
    map.ids = [];
    map.sortedIds = [];
    map.filteredIds = [];
    if (resetSelection) {
      map.selectedIds = {};
    }

    // If user is support and no company is selected we don't need to fetch data
    if (isSupportUser && !selectedCompany) {
      setDataLoaded(true);
      return;
    }
    
    // Fetch data based on user type and selected company
    const fetchData = isSupportUser && selectedCompany 
      ? API.getAccountReceivers(selectedCompany) // Fetch receivers for a selected company if user is support
      : API.getReceivers(); // Fetch all receivers if user is not support or no company selected
  
    fetchData
      .then((res) => {
        res.data.forEach((rx) => {
          const hwWarrantyStartDateDisplay = rx.hwWarrantyStartDate
            ? new Date(rx.hwWarrantyStartDate).toLocaleString(undefined, dateOptions)
            : '';
          const expiryDisplay = rx.expiry
            ? new Date(rx.expiry).toLocaleString(undefined, dateOptions)
            : '';
  
          // Populate the map with formatted data
          map.data[rx.mac] = {
            companyName: rx.companyName,
            email: rx.email,
            modelName: rx.modelName,
            mac: rx.mac,
            serialNo: rx.serialNo,
            hwWarrantyStartDate: rx.hwWarrantyStartDate, 
            hwWarrantyStartDateDisplay, // Formatted date for both display and search
            expiry: rx.expiry,
            expiryDisplay, // Formatted date for both display and search
            checked: false,
          };
        });
        map.filteredIds = Object.keys(map.data);
        map.ids = Object.keys(map.data);
        console.log('Data:', map.data);
        
        if(searchValue !== "") {
          tableRef.current.search(map)
        } else {
          sortMap(map);
          setData(generateDataSlice(map));
          setDataCount(map.sortedIds.length);
        }
        setSelectedIds(map.selectedIds);
        setTotalDataCount(map.ids.length);
        setDataLoaded(true);
      })
      .catch((error) => {
        // Handle the API request error
        console.error('API request error:', error);
        setDataLoaded(true);
      });
  }  

  useEffect(() => {
    // Perform field validations
    validateRxExpiration(checkedRxExpiration);
  }, [checkedRxExpiration]);

  const validateRxExpiration = (value) => {
    setcheckedRxExpirationValid(InputValidation.validateEmpty(String(value)));
  };

  const checkedRxExpirationChange = (value) => {
    setCheckedRxExpiration(value);
    validateRxExpiration(value);
  };

  function handleEditReceiver(e){
    e.preventDefault();
    console.log(Object.keys(selectedIds), checkedRxExpiration);
    setSubmitted(true);
    if(checkedRxExpirationValid)
      return;
    API.editRxExpiration(Object.keys(selectedIds), checkedRxExpiration)
      .then((res)=>{
        loadTable(hwDataMap, false);
        setCheckedRxExpiration('');
        setSuccess(<FormattedMessage id="EDIT_RX_EXPIRATION_SUCCESS" />)
        closeModal('hwModal');
      })
  }

  function handleDeleteReceivers(e) {
    e.preventDefault();
    API.deleteRx(Object.keys(selectedIds))
    .then((res)=>{
      loadTable(hwDataMap);
      setSuccess(<FormattedMessage id="DELETED_RECEIVERS_SUCCESS" />)
    })
  }

  function handleDeselectCompanies() {
		// Reset filteredIds to include all data entries
		hwDataMap.filteredIds = [];

		// Reset sortedIds to include all data entries
		sortMap(hwDataMap);
	
		// Reset the data count to the length of all data entries
		setDataCount(hwDataMap.filteredIds.length);
		setTotalDataCount(hwDataMap.filteredIds.length);
	
		// Generate a data slice using the unfiltered and sorted IDs
		const slicedData = generateDataSlice(hwDataMap, 0);
	
		// Update the data state to display the unfiltered data
		setData(slicedData);
	}

  // Initialize table columns
  const editPermission = permissionIds.includes(constants.permissionIds.editHwWarranty);

  const tableColumnArray = [
    {
      Header: 'MODEL_NAME',  
      id: 'modelName',  
      accessor: 'modelName',  
      isVisible: true,  
    },
    {
      Header: 'MAC',
      id: 'mac',
      accessor: 'mac',
      isVisible: true,
    },
    {
      Header: 'SERIAL_NUMBER',  
      id: 'serialNo',  
      accessor: 'serialNo',  
      isVisible: true,  
    },
    {
      Header: 'BORN_ON_DATE',  
      id: 'hwWarrantyStartDate',  
      accessor: 'hwWarrantyStartDateDisplay',
      width: 100,
      isVisible: true,  
    },
    {
      Header: 'EXPIRATION',  
      id: 'expiry',  
      accessor: 'expiryDisplay',
      width: 100,
      isVisible: true,  
    },
  ]

  if(editPermission){
    tableColumnArray.splice(1, 0, {
      Header: 'COMPANY',  
      id: 'companyName',  
      accessor: 'companyName',  
      isVisible: true,  
    })
  
    tableColumnArray.splice(1, 0, {
      Header: 'OWNER_EMAIL',  
      id: 'email',  
      accessor: 'email',  
      isVisible: true,  
  })}
  
  const tableColumns = React.useMemo(
  
  () => tableColumnArray, [])

  /**
   * Handle importing receivers from a file
   */
  function uploadFile() {
    if (selectedCompanyImport && importFile) {
      API.importReceivers(importFile, selectedCompanyImport)
        .then(() => {
          loadTable(hwDataMap, false);
          setSuccess(<FormattedMessage id="IMPORT_RECEIVERS_SUCCESS" />)
        }).catch((error) => {
          console.error('API request error:', error);
          setError(<FormattedMessage id="IMPORT_RECEIVERS_ERROR" />);
        });
    } else {
      // Handle the case where either `selectedCompanyImport` or `importFile` is missing.
      console.error("Both company and a file must be selected for the import.");
      setError(<FormattedMessage id="SELECTE_COMPANY_FOR_IMPORT_RECEIVERS" />)
    }
  }

  const propButtons = 
    <>
      {isSupportUser &&
        <> 
          <button type="button" className="btn" 
            disabled={Object.keys(selectedIds).length === 0}
            data-bs-toggle="modal"
            data-bs-target={`#hwModal`}>
            <FormattedMessage id="EDIT_EXPIRATION" defaultMessage="Edit Expiration" />
          </button>
          <button type="button" className="btn"
            disabled={Object.keys(selectedIds).length === 0}
            onClick={handleDeleteReceivers}
            id="deleteBtn"
          >
            <FormattedMessage id="DELETE_RECEIVER" defaultMessage="Delete Receiver" />
          </button>
          <button type="button" className="btn" 
            data-bs-toggle="modal"
            data-bs-target={`#importModal`}>
            <FormattedMessage id="IMPORT_RECEIVERS" defaultMessage="Import Receivers" />
          </button>
          {/* <button className="btn btn-primary">
            <label htmlFor="userFormFile" style={{ cursor: 'pointer' }}>
              Import Receiver
            </label>
            <input
              type="file"
              id="userFormFile"
              hidden
              onChange={uploadFile}
            />
          </button> */}
        </>
      }
    </> 

  // Props to pass to our table 
  const tableProps = {
    // The tableKey is for task#20542.
    // Each table requires a unique key to prevent preferences from being overwritten.
    tableKey: "hardware_warranty_table",
    pageType: constants.pageType.HardwareWarranty,
    modalId,
    columns: tableColumns,
    data, setData,
    dataMap: hwDataMap,
    // Data Handling props
    generateDataSlice,
    setDataCount,
    sortMap,
    dataCount,
    totalDataCount,
    startIndex: startIndexForTable,
    selectedIds, setSelectedIds,
    propButtons,
    setSortBy,
    success, setSuccess,
    error, setError,
    sortByCol,
    sortByAsc,
    searchValue, 
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
  }

  // Props to pass to the select table
  const selectTableProps = {
    success, setSuccess,
    error, setError,
    setCompanies,
    displayReceivers,
  }
  
  // Props to pass to our modal component
  const modalProps = {
    checkedRxExpiration, setCheckedRxExpiration,
    handleEditReceiver,
    success,
    error,
    checkedRxExpirationValid,
    checkedRxExpirationChange,
    submitted,
  }

  // Import modal props
  const importModalProps = {
    uploadFile,
    companies,
    selectedCompanyImport, setSelectedCompanyImport,
    importFile, setImportFile,
    success,
    error,
  }

  return (
    <div>
      <ImportModal {...importModalProps} />
      <HwModal {...modalProps} />
      {isSupportUser ? (
        <CompanySelectTable {...selectTableProps} />
      ) : null}
      {<Table {...tableProps} />}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(HardwareWarranty)